module.exports = __webpack_public_path__ + "static/media/panchayatGuruLogo.249bac08.svg";